/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVialFlask: {
  name: 'vial-flask';
  data: string;
} = {
  name: 'vial-flask',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1.5v4.37L.563 14.757A.5.5 0 0 0 1 15.5h9a.5.5 0 0 0 0-1H1.85l4.587-8.257A.5.5 0 0 0 6.5 6V1.5h1V6a.5.5 0 0 0 .063.243l2 3.6a.5.5 0 1 0 .874-.486L8.5 5.87V1.5H9a.5.5 0 0 0 0-1H5a.5.5 0 0 0 0 1h.5Zm5.5-1a.5.5 0 0 0 0 1h.5V14a1.5 1.5 0 0 0 3 0V1.5h.5a.5.5 0 0 0 0-1h-4Zm1.5 1V14a.5.5 0 0 0 1 0V1.5h-1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
